import SupplierDue from '../timetable/supplierDue';
export default function SupplierDueTab(props) {

    const projectId = props.projectId
return (
    <div>
        <SupplierDue isInProject = {true} projectId = {projectId}></SupplierDue>
    </div>
)};